import React from 'react';
import classNames from 'classnames';
import TransitionGroup from 'react-transition-group/TransitionGroup';
import Transition from 'react-transition-group/CSSTransition';
import {SVGIcon} from '@homeaway/react-svg';
import {ARROW_LEFT__24} from '@homeaway/svg-defs';

import {FlagsMenu} from './flags-menu/FlagsMenu';
import {HelpMenu} from './help-menu/HelpMenu';
import {LocaleSwitcherMenu} from './locale-switcher-menu/LocaleSwitcherMenu';
import {TrayMenu} from './tray-menu/TrayMenu';
import {namedEvents, linkLocations} from '../../utils/edap';
import {TrackingContext} from '@homeaway/react-event-tracking';

import './Tray.less';
import CurrencySelectorConnector from '../../connectors/CurrencySelectorConnector';

export class Tray extends React.Component {
    state = {
        activeMenu: 'tray',
    };

    // eslint-disable-next-line complexity
    componentDidUpdate(prevProps) {
        if (this.props.isOpen === false && this.props.isOpen !== prevProps.isOpen) {
            setTimeout(/* istanbul ignore next */() => this.setActiveMenu('tray'), 300);
        }
        if (this.props.isOpen && this.props.isOpen !== prevProps.isOpen && this.props.currencySelectorVariant === 2) {
            this.context.trigger(namedEvents.CURRENCY_SELECTOR_PRESENTED, {
                action_location: linkLocations.SIDEBAR_CURRENCY_SELECTOR,
                displaycurrency: this.props.currencyCode
            });
        }
    }

    static contextType = TrackingContext;
    x = null;

    transitionProps = {
        backdrop: {
            classNames: {
                enter: 'site-header-tray__backdrop--enter',
                enterActive: 'site-header-tray__backdrop--enter-active',
                exit: 'site-header-tray__backdrop--exit',
                exitActive: 'site-header-tray__backdrop--exit-active',
            },
            timeout: 700,
        },
        menu: {
            classNames: {
                enter: 'site-header-tray__menu--enter',
                enterActive: 'site-header-tray__menu--enter-active',
                exit: 'site-header-tray__menu--exit',
                exitActive: 'site-header-tray__menu--exit-active',
            },
            timeout: 700,
        },
        drawer: {
            classNames: {
                enter: 'site-header-tray__drawer--enter',
                enterActive: 'site-header-tray__drawer--enter-active',
                exit: 'site-header-tray__drawer--exit',
                exitActive: 'site-header-tray__drawer--exit-active',
            },
            timeout: 700,
        },
        avatar: {
            classNames: {
                enter: 'site-header-tray__menu-avatar--enter',
                enterActive: 'site-header-tray__menu-avatar--enter-active',
                exit: 'site-header-tray__menu-avatar--exit',
                exitActive: 'site-header-tray__menu-avatar--exit-active',
            },
            timeout: 700
        },
        back: {
            classNames: {
                enter: 'site-header-tray__menu-back--enter',
                enterActive: 'site-header-tray__menu-back--enter-active',
                exit: 'site-header-tray__menu-back--exit',
                exitActive: 'site-header-tray__menu-back--exit-active',
            },
            timeout: 700
        }
    };

    get className() {
        return classNames(
            'site-header-tray',
            {'site-header-tray--open': this.props.isOpen},
        );
    }

    get feedbackComponent() {
        if (!this.props.isMobile) {
            return null;
        }

        return this.props.feedbackComponent;
    }

    getLocaleSwitcher() {
        if (!this.props.localeSwitcher || !this.props.languageCode) {
            return null;
        }
        let localeSwitcher = this.props.localeSwitcher;
        let index = localeSwitcher.locales.findIndex((item) => {
            return item.locale === this.props.languageCode;
        });
        if (index > 0) {
            localeSwitcher.locales.unshift(localeSwitcher.locales[index]);
            localeSwitcher.locales.splice(index + 1, 1);
        }
        return localeSwitcher;
    }

    getPopularCurrencies() {
        if (this.props.globalizationSelector) {
            return this.getPopularCurrencyData(this.props.globalizationSelector.currencySelector.siteDefaultCurrency, this.props.globalizationSelector.currencySelector.popularCurrencies);
        }
        return null;
    }

    getAllCurrencies() {
        return this.props.globalizationSelector.currencySelector.currencies;
    }

    getPopularCurrencyData(defaultSiteCurrency, popularCurrencies) {
        if (!popularCurrencies) {
            popularCurrencies = this.setPopularCurrencyData();
        }
        if (!defaultSiteCurrency) {
            return popularCurrencies;
        }
        let selectedCurrencyInList = popularCurrencies.filter((currency) => {
            return currency.code === defaultSiteCurrency.code;
        });
        if (!selectedCurrencyInList.length) {
            popularCurrencies.unshift(defaultSiteCurrency);
        } else {
            let index = popularCurrencies.findIndex((currency) => {
                return currency.code === defaultSiteCurrency.code;
            });
            if (index > 0) {
                popularCurrencies.splice(index, 1);
                popularCurrencies.unshift(defaultSiteCurrency);
            }
        }
        return popularCurrencies;
    }

    setPopularCurrencyData() {
        return ([
            {code: 'USD', symbol: '$', name: 'US Dollar'},
            {code: 'EUR', symbol: '€', name: 'Euro'},
            {code: 'GBP', symbol: '£', name: 'British Pound Sterling'}
        ]);
    }

    handleClickBack = () => {
        this.setActiveMenu('tray');
    }

    handleClickBackdrop = () => {
        this.props.handleToggleOpen();
    }

    setActiveMenu = (menu = 'tray') => {
        this.setState({
            activeMenu: menu,
        });
    }

    handleShowAllCurrenciesClick = () => {
        this.setActiveMenu('all-currency-menu');
        this.context.trigger(namedEvents.ALL_CURRENCY_SELECTED, {
            action_location: linkLocations.SIDEBAR_TOP_CURRENCY_LIST,
            displaycurrency: this.props.currencyCode,
            set_type: 'ALL'
        });
        this.context.trigger(namedEvents.CURRENCY_SET_PRESENTED, {
            action_location: linkLocations.SIDEBAR_ALL_CURRENCY_LIST,
            displaycurrency: this.props.currencyCode,
            set_type: 'ALL'
        });
    }

    handleTouchStart = (e) => {
        const clientX = e.changedTouches[0].clientX;

        if (clientX && !this.x) {
            this.x = clientX;
        }
    }

    handleTouchEnd = (e) => {
        const clientX = e.changedTouches[0].clientX;
        if (clientX && this.x - clientX < -100) {
            if (this.state.activeMenu === 'tray') {
                this.props.handleToggleOpen();
            } else {
                this.setActiveMenu('tray');
            }
        }
        this.x = null;
    }

    // eslint-disable-next-line complexity
    render() {
        if (!this.props.isMobile) {
            return null;
        }
        return (
            <div className={this.className} onTouchEnd={this.handleTouchEnd} onTouchStart={this.handleTouchStart}>
                <TransitionGroup component="div" key="header-backdrop">
                    {this.props.isOpen && (
                        <Transition {...this.transitionProps.backdrop}>
                            <div
                                className="site-header-tray__backdrop"
                                onClick={this.handleClickBackdrop}
                                onKeyPress={this.handleClickBackdrop}
                                role="none"
                            />
                        </Transition>
                    )}
                </TransitionGroup>
                <div className="site-header-tray__container">
                    <div className="site-header-tray__container-header">
                        {!this.props.traveler && this.props.login && (
                            <div className="site-header-tray__header">
                                <TransitionGroup className="site-header-tray__header--wrapper" component="div" key="header-mobile-header">
                                    {this.state.activeMenu !== 'tray' &&
                                        <Transition {...this.transitionProps.back}>
                                            <div className="site-header-tray__menu-back"
                                                onClick={this.handleClickBack}
                                                onKeyPress={this.handleClickBack}
                                                role="button"
                                                tabIndex={0}
                                            >
                                                <SVGIcon inlineFlex markup={ARROW_LEFT__24}/>
                                            </div>
                                        </Transition>
                                    }
                                </TransitionGroup>
                            </div>
                        )}
                        {this.props.traveler && (
                            <div className="site-header-tray__header site-header-tray__header--traveler">

                                <TransitionGroup className="site-header-tray__header--wrapper" component="div" key="header-mobile-header">
                                    {this.state.activeMenu !== 'tray' &&
                                        <Transition {...this.transitionProps.back}>
                                            <div className="site-header-tray__menu-back"
                                                onClick={this.handleClickBack}
                                                onKeyPress={this.handleClickBack}
                                                role="button"
                                                tabIndex={0}
                                            >
                                                <SVGIcon inlineFlex markup={ARROW_LEFT__24}/>
                                            </div>
                                        </Transition>
                                    }

                                    {this.state.activeMenu === 'tray' &&
                                        <Transition {...this.transitionProps.avatar}>
                                            <div className="site-header-tray__menu-avatar">
                                                <img
                                                    alt="avatar"
                                                    aria-hidden="true"
                                                    className="site-header-tray__header-avatar img-circle"
                                                    role="presentation"
                                                    src={this.props.traveler.avatar.image}
                                                />
                                                {this.props.traveler && this.props.traveler.items && this.props.traveler.items.filter((item) => item.cssClass === 'se-traveler-profile').map((item, index) => {
                                                    // FIXME: This is a hack to identify the inbox item
                                                    // TODO: Sort out a maintainable way to indentify and handle inbox and inbox data
                                                    return (
                                                        <a className="site-header-tray__menu-item-link" data-bypass="true" href={item.link} key={item.link || index}>
                                                            <span className="site-header-tray__header-greeting">
                                                                {this.props.traveler.label}
                                                            </span>
                                                        </a>
                                                    );
                                                })}
                                            </div>
                                        </Transition>
                                    }
                                </TransitionGroup>
                            </div>
                        )}
                    </div>
                    <TransitionGroup className="site-header-tray__container__items" component="div" key="header-mobile-container">
                        {this.state.activeMenu === 'tray' && (
                            <Transition {...this.transitionProps.menu}>
                                <TrayMenu
                                    countryCode={this.props.countryCode}
                                    currencyCode={this.props.currencyCode}
                                    currencySelectorVariant={this.props.currencySelectorVariant}
                                    currencyList={this.getPopularCurrencies()}
                                    localeSwitcher={this.props.localeSwitcher}
                                    extraNav={this.props.extraNav}
                                    feedbackComponent={this.feedbackComponent}
                                    flags={this.props.flags}
                                    globalizationSelector={this.props.globalizationSelector}
                                    handleTravelerLogin={this.handleClickBackdrop}
                                    help={this.props.help}
                                    inbox={this.props.inbox}
                                    isOpen={this.props.isOpen}
                                    isMobile={this.props.isMobile}
                                    languageCode={this.props.languageCode}
                                    login={this.props.login}
                                    lyp={this.props.lyp}
                                    onGlobalSelectorChange={this.props.onGlobalSelectorChange}
                                    renderCountryLanguageSelector={this.props.renderCountryLanguageSelector}
                                    renderCurrencySelector={this.props.renderCurrencySelector}
                                    scratchpad={this.props.scratchpad}
                                    setActiveMenu={this.setActiveMenu}
                                    traveler={this.props.traveler}
                                    signUp={this.props.signUp}
                                />
                            </Transition>
                        )}

                        {this.state.activeMenu === 'flag' && (
                            <Transition {...this.transitionProps.drawer}>
                                <FlagsMenu
                                    flags={this.props.flags}
                                    setActiveMenu={this.setActiveMenu}
                                />
                            </Transition>
                        )}

                        {this.state.activeMenu === 'help' && (
                            <Transition {...this.transitionProps.drawer}>
                                <HelpMenu
                                    help={this.props.help}
                                    setActiveMenu={this.setActiveMenu}
                                />
                            </Transition>
                        )}

                        {this.state.activeMenu === 'locale-switcher' && this.props.localeSwitcher && this.props.localeSwitcher.locales && (
                            <Transition {...this.transitionProps.drawer}>
                                <LocaleSwitcherMenu
                                    localeSwitcher={this.getLocaleSwitcher()} languageCode={this.props.languageCode}
                                />
                            </Transition>
                        )}

                        {this.state.activeMenu === 'top-currency-menu' && (
                            <Transition {...this.transitionProps.drawer}>
                                <CurrencySelectorConnector
                                    {...this.props.globalizationSelector}
                                    currencyCode={this.props.currencyCode}
                                    currencyList={this.getPopularCurrencies()}
                                    isTopCurrenciesView
                                    handleShowAllCurrenciesClick={this.handleShowAllCurrenciesClick}
                                />
                            </Transition>
                        )}

                        {this.state.activeMenu === 'all-currency-menu' && (
                            <Transition {...this.transitionProps.drawer}>
                                <CurrencySelectorConnector
                                    {...this.props.globalizationSelector}
                                    currencyCode={this.props.currencyCode}
                                    currencyList={this.getAllCurrencies()}
                                    handleShowAllCurrenciesClick={this.handleShowAllCurrenciesClick}
                                />
                            </Transition>
                        )}
                    </TransitionGroup>
                </div>
            </div>
        );
    }
}
